import { createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "revico-community-talk-post-profile-picture" }
const _hoisted_2 = { class: "revico-community-talk-post-profile-picture-wrapper" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["name", "disabled"]
const _hoisted_5 = { class: "revico-community-talk-post-profile-picture-description" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("li", { class: "revico-community-talk-post-profile-picture-description--item" }, "アップロードできる画像拡張子はpng/jpg/jpeg/gif(静止画)です", -1 /* HOISTED */)
const _hoisted_7 = { class: "revico-community-talk-post-profile-picture-description--item" }
const _hoisted_8 = {
  key: 0,
  class: "revico-community-talk-post-profile-picture-preview"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "revico-community-talk-post-profile-picture-error-message"
}
const _hoisted_11 = {
  key: 2,
  class: "revico-community-talk-post-profile-picture-error-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["ApiPostLoadMaster"], { status: $setup.status }, {
      beforeRequest: _withCtx(() => [
        _createVNode($setup["CustomLabel"], {
          class: "revico-community-talk-post-profile-picture--label",
          text: "プロフィール画像",
          disabled: $props.disabled
        }, null, 8 /* PROPS */, ["disabled"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "revico-community-talk-post-profile-picture--input-button",
            disabled: $props.disabled || $setup.isProcessing,
            onClick: $setup.onClickInputFileButton
          }, "ファイルを選択", 8 /* PROPS */, _hoisted_3),
          _createElementVNode("input", {
            ref: "inputElement",
            onChange: $setup.picture,
            type: "file",
            accept: "image/gif, image/png, image/jpeg",
            name: $setup.name,
            disabled: $props.disabled || $setup.isProcessing,
            class: "revico-community-talk-post-profile-picture--input"
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_4),
          _createCommentVNode(" 画像投稿時の注意文言 "),
          _createElementVNode("ul", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("li", _hoisted_7, "画像サイズの上限は" + _toDisplayString($setup.MediaUtil.maxFileSize.image / 1024 / 1024) + "MBです。", 1 /* TEXT */)
          ]),
          _createCommentVNode(" 画像のプレビュー "),
          ($setup.communityTalkStore.getCommunityTalkUserProfilePicViewModel().profilePicUrl)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                _createElementVNode("img", {
                  class: "revico-community-talk-post-profile-picture-preview--img",
                  src: $setup.communityTalkStore.getCommunityTalkUserProfilePicViewModel().profilePicUrl,
                  onError: $setup.detachImage
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_9),
                _createCommentVNode(" プレビュー解除ボタン "),
                _createElementVNode("button", {
                  class: "revico-community-talk-post-profile-picture-preview--detach-button",
                  type: "button",
                  onClick: $setup.detachImage
                }, "選択を解除")
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" 投稿画像APIからのAPIエラーメッセージ "),
          ($setup.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($setup.errorMessage), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" 親コンポーネントからのAPIエラーメッセージ "),
          ($setup.parentErrorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($setup.parentErrorMessage), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["status"])
  ]))
}